<ng-template #headerTemplate>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/dashboard" (click)="dismissModal()"></ion-back-button>
      </ion-buttons>
      <ion-title>Informationen</ion-title>
    </ion-toolbar>
  </ion-header>
</ng-template>

  <ion-grid>
    <ion-row>
      <ion-col>
        <p>Version:</p>
        <p>{{'LABEL.IPADR' | translate}}</p>
        <p>{{'LABEL.HWID' | translate}}</p>
        <p>{{'LABEL.LICENSENUMBER' | translate}}</p>
        <p>{{'LABEL.SERIALNUMBER' | translate}}</p>
      </ion-col>
      <ion-col>
        <p *ngIf="appVersionNumber; else NoVersion">{{appVersionNumber}}</p>
        <ng-template #NoVersion>
          <p>1.9.2</p>
        </ng-template>
        <p>{{IPADRESS()}}</p>
        <p>{{hwid()}}</p>
        <p>{{licenseNumber | async}}</p>
        <p>{{serialNumber | async}}</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p>{{'LABEL.THERMAL_STATUS' | translate}}</p>
        <p>{{'LABEL.CPU_TEMP' | translate}}</p>
      </ion-col>
      <ion-col>
        <p>
          <ion-spinner *ngIf="thermalLoading(); else thermalStatusValue" name="dots"></ion-spinner>
          <ng-template #thermalStatusValue>
            {{ thermal()?.thermalStatusLabel || 'N/A' }}
            <span *ngIf="thermal() && thermal().thermalStatus > 0">({{ thermal().thermalStatus }})</span>
          </ng-template>
        </p>
        <p>
          <ion-spinner *ngIf="thermalLoading(); else cpuTempValue" name="dots"></ion-spinner>
          <ng-template #cpuTempValue>
            {{ maxCpuTemp() != null ? (maxCpuTemp() + ' °C') : 'N/A' }}
          </ng-template>
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <p>{{'LABEL.PEAK_CPU_TEMP' | translate}}</p>
        <p>{{'LABEL.MIN_CPU_TEMP' | translate}}</p>
        <p>{{'LABEL.WORST_THERMAL_STATUS' | translate}}</p>
        <p>{{'LABEL.TRACKING_SINCE' | translate}}</p>
      </ion-col>
      <ion-col>
        <p>
          <ion-spinner *ngIf="thermalLoading(); else peakCpuValue" name="dots"></ion-spinner>
          <ng-template #peakCpuValue>
            <ng-container *ngIf="peaks()?.peakCpuTemp != null; else noPeakCpu">
              {{ peaks().peakCpuTemp | number:'1.0-1' }} °C
              <span>({{ peaks().peakCpuTempAt | date:'dd.MM HH:mm' }})</span>
            </ng-container>
            <ng-template #noPeakCpu>N/A</ng-template>
          </ng-template>
        </p>
        <p>
          <ion-spinner *ngIf="thermalLoading(); else minCpuValue" name="dots"></ion-spinner>
          <ng-template #minCpuValue>
            <ng-container *ngIf="peaks()?.minCpuTemp != null; else noMinCpu">
              {{ peaks().minCpuTemp | number:'1.0-1' }} °C
              <span>({{ peaks().minCpuTempAt | date:'dd.MM HH:mm' }})</span>
            </ng-container>
            <ng-template #noMinCpu>N/A</ng-template>
          </ng-template>
        </p>
        <p>
          <ion-spinner *ngIf="thermalLoading(); else worstValue" name="dots"></ion-spinner>
          <ng-template #worstValue>
            <ng-container *ngIf="peaks()?.worstThermalStatusLabel; else noWorst">
              {{ peaks().worstThermalStatusLabel }}
              <span>({{ peaks().worstThermalStatusAt | date:'dd.MM HH:mm' }})</span>
            </ng-container>
            <ng-template #noWorst>N/A</ng-template>
          </ng-template>
        </p>
        <p>
          <ion-spinner *ngIf="thermalLoading(); else trackingValue" name="dots"></ion-spinner>
          <ng-template #trackingValue>
            {{ peaks()?.trackingSince ? (peaks().trackingSince | date:'dd.MM HH:mm') : 'N/A' }}
          </ng-template>
        </p>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="6">
        <ion-button size="small" fill="outline" (click)="resetThermalPeaks()">
          {{'BTN.RESET_THERMAL_PEAKS' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="6">
        <app-language-switcher class="ion-margin-top"></app-language-switcher>
      </ion-col>
    </ion-row>
  </ion-grid>

<ng-template #footerTemplate>
  <ion-row class="ion-text-center">
    <ion-col (click)="openBrowser('https://hxa.io/impressum/')">
      <p>{{'INFO_VIEW.IMPRINT' | translate}}</p>
    </ion-col>
    <ion-col (click)="openBrowser('https://hxa.io/privacy/')">
      <p>{{'BTN.DATAPRIVACY' | translate}}</p>
    </ion-col>
    <ion-col (click)="openBrowser('https://hxa.io/support/')">
      <p>Support</p>
    </ion-col>
  </ion-row>
</ng-template>